export const addTimezoneAbbreviationToLabels = (labels, timezoneAbbreviation) => {
    return labels.map((label) => `${label} (${timezoneAbbreviation})`);
};
